import React from 'react';
import Tabs from '@shared/ui/Tabs';

export interface AdminTabDef {
  key: string;
  label: string;
}

interface AdminTabsProps {
  tabs: AdminTabDef[];
  activeKey: string;
  onChange: (key: string) => void;
  /** Accessible name for the tablist — set it when the bar has no visible heading. */
  ariaLabel?: string;
}

/**
 * Standard tab bar for multi-view admin tools (e.g. Accounts, Templates).
 * Keep tab state in the URL (?tab=…) so views are linkable.
 *
 * P2-03: now a thin adapter over the shared <Tabs> primitive. The name and props
 * are unchanged so the admin pages using it did not have to change, but it gains
 * the shared keyboard handling and, notably, an overflow menu — this bar was
 * `overflow-x-auto`, which on a narrow window hid admin views behind a horizontal
 * scroll rather than surfacing them.
 */
const AdminTabs: React.FC<AdminTabsProps> = ({ tabs, activeKey, onChange, ariaLabel }) => (
  <Tabs
    level="panel"
    ariaLabel={ariaLabel}
    tabs={tabs.map((tab) => ({ id: tab.key, label: tab.label }))}
    activeId={activeKey}
    onChange={onChange}
  />
);

export default AdminTabs;
